import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';

import { searchAllPracticesAtom } from '../modules/patientList/atoms';
import { useDebounce } from '../utils/hooks/useDebounce';

import { makeAPIRequestReactQuery } from './api';

export const usePatientNameSearch = (
  patientName: string | null,
  options?: UseQueryOptions<string[], unknown, string[], string[]>,
) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector((state: any) => state.login.user);
  const isOrgSearchEnabled = useAtomValue(searchAllPracticesAtom);

  const { debouncedValue: debouncedPatientName } = useDebounce(
    patientName || '',
    250,
  );

  return useQuery(
    [currentPractice, 'patients', debouncedPatientName],
    () =>
      makeAPIRequestReactQuery<string[]>(`patient`, undefined, 'get', {
        params: {
          name: debouncedPatientName,
          orgSearch: isOrgSearchEnabled,
        },
        headers: {
          practice: currentPractice,
          org: currentOrg,
        },
      }),
    {
      enabled: !!currentPractice && !!debouncedPatientName?.length,
      ...options,
    },
  );
};
